export const productFruitsIds = {
  navigation: {
    dashboard: 'navigation-dashboard',
    quotations: 'navigation-quotations',
    invoices: 'navigation-invoices',
    products: 'navigation-products',
    clients: 'navigation-clients',
    network: 'navigation-network',
    forum: 'navigation-forum',
    jobPosts: 'navigation-job-posts',
  },
  dashboard: {
    header: { createInvoice: 'dashboard-header-create-invoice' },
  },
  quotations: {
    header: { createQuotation: 'quotations-header-create-quotation' },
  },
  invoices: {
    header: { createInvoice: 'invoices-header-create-invoice' },
  },
  creditNotes: {
    header: { createCreditNote: 'credit-notes-header-create-credit-note' },
  },
  invoiceTemplates: {
    header: { createInvoiceTemplate: 'invoice-templates-header-create-invoice-template' },
  },
  products: {
    header: { createProduct: 'products-header-create-product' },
  },
  clients: {
    header: { createClient: 'clients-header-create-client' },
  },
  forum: {
    header: { createPost: 'forum-header-create-post' },
  },
  jobPosts: {
    header: { createJobPost: 'job-posts-header-create-job-post' },
  },
} as const;
